import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Editing,
    Summary,
    GroupItem,
    TotalItem
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import CustomStore from 'devextreme/data/custom_store';
import Request from "../../components/api/Request";
import { showToast, parseDate, hasRole, parseApiDate } from "../../utils/Utils";
import * as Utils from '../../utils/Utils';
import { ToastType } from "../../constants/Constants";
import * as AppActions from '../../actions/AppActions';
import Box, {
    Item
} from 'devextreme-react/box';
import './CariDonemFinansRapor.scss';

const CariDonemDomainFinansOzetRapor = (props) => {

    const dispatch = useDispatch();

    const [store, setStore] = useState(null);


    useEffect(() => {
        setStore(getStore());
    }, [])


    let dataGrid = null;

    const getStore = () => {
        
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }
                let url = "/cariDonemFinansRapor/getCariDonemFinansOzetRaporInfoList/" +props.data.id;
                
                if(props.dataType =="finansRaporDomain"){
                    url = "/cariDonemFinansRapor/getCariDonemFinansOzetRaporDomainInfoList/" +props.data.id;
                }
                const request = new Request(url , "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
 

    return (
        <div >
            <DataGrid
                className="cariDonemDomainFinansOzetRaporGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Export enabled={true} />
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'name'} width={200} caption={'Firma'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="donem" width={70} caption={'Dönem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="kanunNumarasi" width={70} caption={'Kanun'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="sayi" width={70} caption={'Sayı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="fark" width={150} caption={'Fark'} dataType="string" visible={true} allowEditing={false} />

                <Column dataField="primDestegiYuzde5Dahil" width={150} caption={'Prim Deteği %5 Dahil'} dataType="string" visible={true} allowEditing={false} /> 
                <Column dataField="primDestegiYuzde5Haric" width={150} caption={'Prim Deteği %5 hariç'} dataType="string" visible={true} allowEditing={false} /> 
                <Column dataField="primDestegi" width={150} caption={'Prim Deteği'} dataType="string" visible={true} allowEditing={false} /> 
               

                <Summary  > 
                    <TotalItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                      <TotalItem
                        column="primDestegiYuzde5Dahil"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                       <TotalItem
                        column="primDestegiYuzde5Haric"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                       <TotalItem
                        column="primDestegi"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                </Summary>

            </DataGrid>

        </div>
    )
}

export default CariDonemDomainFinansOzetRapor;
